module.exports = __webpack_public_path__ + "img/economic_stability.1f685325.jpg";